import { Injectable } from '@angular/core';
import * as cfg from 'src/config.json';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import PouchDB from 'pouchdb';
import { BehaviorSubject } from 'rxjs';
import { CryptoService } from '../services/crypto.service';

// import * as dbt from '../tools-db';
import { langsWithFullTranslation, Menu, Order, User } from '../models';
import PouchDb from 'pouchdb-browser';
import { DbToolsService } from '../services/db-tools.service';
import { Router } from '@angular/router';
import { LogService } from '../services/log.service';

import { environment } from '../../environments/environment';
import { pairwise } from 'rxjs/operators';
import Fuse from 'fuse.js';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public prod = environment.production;
  public activeLogin$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  private config = cfg.default.auth; // 'local'/'test-gcp
  public loggedUser$ = new BehaviorSubject(new User());
  public ordersInLocalUserDB$: BehaviorSubject<Order[]> = new BehaviorSubject([]);
  public authLoading$: BehaviorSubject<boolean> = new BehaviorSubject(true)
  public userDbSynced$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public publicDbSynced$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public privateDbSynced$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public orderListOrMenuUpdated$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public paymentsListUpdateInProgress$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public menuLoaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public online$: BehaviorSubject<boolean> = new BehaviorSubject(null);
  public connectionLost = false;

  public refreshingClientData$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public refreshingRestData$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public dbUserLocal: any = null;
  public dbUserRemote: any = null;

  public otherDbs = [];
  public subsDict: {} = {};

  private blurStartTime: number = null;
  private defaultAfterBlurDelay: number = 120 * 1000; // 120 seconds
  // public bc = new BroadcastChannel('look@menu');

  public fuse: Fuse<{ type: string, sidx: number, idx?: number, content: string }> = new Fuse([], {
    keys: ['content'],
    includeMatches: true,
    // findAllMatches:true,
    useExtendedSearch: true,
    // includeScore: true,
    // shouldSort: true,
    ignoreLocation: true,
    threshold: 0.3
  });
  public menuItemFilter$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public appLang: string = ''; // for local dev
  public clientLang: string = ''; // for local dev

  public screenOn$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public wakeLock: any = null;
  public isWakeLockAvailable: boolean = false;


  constructor(
    private http: HttpClient,
    private cryp: CryptoService,
    private dbt: DbToolsService,
    private router: Router,
    private log: LogService
  ) {
    if (!environment.local){
      const clientLang = localStorage.getItem('lang')
      if (clientLang ) {
        this.appLang = location.pathname.split('/')[1];
        this.clientLang = clientLang;
      // }
      // if ((new URLSearchParams(location.search).get('l'))){
      //   this.appLang = location.pathname.split('/')[1];
      //   this.clientLang = (new URLSearchParams(location.search).get('l'));
      } else {
        this.appLang = location.pathname.split('/')[1];
        this.clientLang = navigator.language.split('-')[0];
      }      
    } else {
      this.appLang = 'pl';
      const clientLang = navigator.language.split('-')[0]
      localStorage.setItem('lang',clientLang)
      this.clientLang = clientLang;

    };
    this.isWakeLockAvailable = 'wakeLock' in navigator;
    window.addEventListener('online', () => {
      this.log.log(`online`);
      this.online$.next(true);
    });
    window.addEventListener('offline', () => {
      this.log.log(`offline`);
      this.connectionLost = true;
      this.online$.next(false);
    });
    window.addEventListener('blur', () => {
      this.log.log(`blur`);
      this.blurStartTime = Date.now();
    });
    window.addEventListener('focus', () => {
      this.log.log(`focus`);
      if (this.blurStartTime !== null && ((Date.now() - this.blurStartTime) > this.defaultAfterBlurDelay)) {
        this.connectionLost = true;
        this.online$.next(false);
        this.online$.next(true)
      }
    });
    // this.online$.subscribe(s => this.log.log(s ? 'online' : 'offline'))
    // this.authLoading$.subscribe(e => this.log.log('authLoading: '+e))
    this.activeLogin$.pipe(
      pairwise()
    ).subscribe({
      next: ([p, n]) => {
        if (p === n) { return; };

      }
    })

    // this.screenOn$.subscribe({next: c => console.warn(c)})
    
    // BroadcastChannel
    // this.bc.onmessage = (e) => {
    //   if (e.data === true) {
    //     this.bc.postMessage(false);
    //     // alert("Another tab of this site just got opened");
    //     this.goToOrigin();
    //   }
    //   if (e.data === false) {
    //     // alert("An instance of this site is already running");
    //   }
    // };
    // this.bc.postMessage(true);

    localStorage.openpages = Date.now();
    let onLocalStorageEvent = (e) => {
      if (e.key == "openpages") {
        // Listen if anybody else is opening the same page!
        this.goToOrigin()
        localStorage.page_available = Date.now();
      }
      if (e.key == "page_available") {
        // alert("page_available");
      }
    };
    window.addEventListener('storage', onLocalStorageEvent, false);

    this.userDbSynced$.subscribe({
      next: v => console.debug(`userDbSynced$: ${v}`)
    });
    this.publicDbSynced$.subscribe({
      next: v => console.debug(`publicDbSynced$: ${v}`)
    })
    this.privateDbSynced$.subscribe({
      next: v => console.debug(`privateDbSynced$: ${v}`)
    })
    this.orderListOrMenuUpdated$.subscribe({
      next: v => console.debug(`orderListOrMenuUpdated$: ${v}`)
    })
    this.authLoading$.subscribe({
      next: v => console.debug(`authLoading$: ${v}`)
    })
  }

  // screen lock
  async toggleScreenOn(on:boolean): Promise<void> {
    if (this.isWakeLockAvailable) {
      if (on) {
        try {
          this.wakeLock = await (navigator as any).wakeLock.request('screen');
          this.wakeLock.onrelease = () => this.screenOn$.next(false);
          this.screenOn$.next(true);          
        } catch (error) {
          // low battery etc.
          this.screenOn$.next(false);
          this.log.log(`TSO#1: ${JSON.stringify(error)}`);
        };        
      } else {
        //off
        await this.wakeLock.release();
        // this.screenOn$.next(false);
      }
    } else {
      // implement video loop solution
    };
  };

  // search and filtering
  updateSearchCollection(m: Menu) {
    const menuItems = m.sections
      .reduce((t, c, i) => [
        ...t, ...c.items.map((p, j) => {
          return {
            sidx: i,
            idx: j,
            content: [
              p.name,
              c.name, // section name
              ...(p.variant ? p.variant : []),
              ...(p.ingr ? p.ingr : []),
              (p.desc ? p.desc : [])
            ].join(', '),
            type: 'menuItem'
          }
        })], []);
    this.fuse.setCollection(menuItems)
    this.menuItemFilter$.next(m.sections.map(s => s.items.map(i => true)));
  }

  searchAndFilter(query: string) {
    if (query === '') {
      this.menuItemFilter$.next(this.menuItemFilter$.getValue().map((i: []) => i.map(_ => true)));
      return;
    }
    if (query.slice(-1) === '!') { return; };
    // {$and:query.split(' ').map(i => {return {content:i}})}
    const res = this.fuse.search(query).map(r => {
      // console.warn(`${r.score} - ${r.item.content}`); 
      return r.item
    });
    const newFilter = this.menuItemFilter$.getValue().map(i => i.map(_ => false));
    const resItems = res.filter(r => r.type.indexOf('menuItem') == 0);
    resItems.forEach(i => newFilter[i.sidx][i.idx] = true);
    this.menuItemFilter$.next(newFilter);
    return;
  };

  goToOrigin() {
    window.location.href = window.location.origin;
  };
  async checkCredentials(login: string, pass: string): Promise<boolean> {
    let credOk = false;
    if (login.length < 3 || pass.length < 3) { return credOk; }

    const headers = new HttpHeaders({ Authorization: 'Basic ' + Buffer.from(login + ':' + pass).toString('base64') });

    try {
      await this.http.head(`${this.config.couchRemoteURL}`, { headers }).toPromise();
      credOk = true;
    } catch (error) {
      credOk = false;
    }
    return credOk;
  };

  async loginWithJWT(login: string, pass: string): Promise<boolean> {
    if (!login || !pass || login.length < 3 || pass.length < 3) {
      this.log.log('wrong login or pass'); return false;
    }

    if (!this.dbUserLocal || this.dbUserLocal.name === this.config.guestDbName) {
      if (this.dbUserLocal) { await this.dbUserLocal.close(); };
      this.dbUserLocal = new PouchDB(this.getUserDatabaseName(login))
    }

    try {
      return await this.connectClient({ login, pass });
    } catch (error) {
      this.log.log(error);
      return false;
    }
  }

  async addUserDetailsToDb({ login, pass, info }): Promise<boolean> {
    try {
      const ckeys = await this.cryp.getKeyPairRSAOAEP();
      const headers = new HttpHeaders({ Authorization: 'Basic ' + Buffer.from(login + ':' + pass).toString('base64') });
      await this.http.put(`${this.config.couchRemoteURL}/${this.getUserDatabaseName(login)}/ckeys`, { _id: 'ckeys', pub: ckeys.pub, priv: ckeys.priv }, { headers }).toPromise();
      await this.http.put(`${this.config.couchRemoteURL}/${this.getUserDatabaseName(login)}/userDetails`,
        info, { headers }).toPromise();
      return true;
    } catch (error) {
      this.log.log(error);
      return false;
    }

  }

  /**
   * 
   * @param {string} login - User login
   * @param {string} pass  - User password
   * @param {string} token - Captcha token
   * @param {Object} info - Object containing user's full name
   * @returns 
   */
  async createNewUser2(login: string, pass: string, token: string, info: {}): Promise<boolean> {
    try {
      const resp = await this.http.post(this.config.createNewUserURL, {
        login,
        pass,
        token,
        info// { email: info['email'] }
      }).toPromise() as any;
      return 'accepted' in resp && resp.accepted.length > 0 && resp.accepted[0] === login;
    } catch (error) {
      this.log.log(error);
      return false;
    }

  }

  /**
   * 
   * 
   */
  async logout(): Promise<boolean> {
    this.authLoading$.next(true);
    localStorage.clear();
    try {
      await this.dbt.deleteByIdDocSafe('jwt:user', this.dbUserRemote);
      // for not firefox
      let dbs = await (indexedDB as any).databases();
      dbs.forEach(db => indexedDB.deleteDatabase(db.name));
    } catch (error) {
      // for firefox...
      const otherRestsDbNames = (await this.dbt.getDocByIdPrefix('jwt:r', this.dbUserLocal))
      .rows.map(r => r.id.split(':')[2])
      .reduce((t,c) => [...t,`_pouch_${c}-private`,`_pouch_${c}-public`],[])

      const dbnames = new Set([
        '_pouch_guest',
        ...Object.values(this.subsDict).filter((s:any) => s.db).map((d:{db}) => `${d.db.prefix}${d.db.name}`),
        ...otherRestsDbNames
      ]);
      dbnames.forEach(dbname => indexedDB.deleteDatabase(dbname));
    };
    
    this.authLoading$.next(false);
    this.goToOrigin();
    return true;
    // console.warn('logout');
    // try {
    //   this.authLoading$.next(true);
    //   // await this.deleteTokens();
    //   localStorage.removeItem('login');
    //   // for (let sync in this.subsDict) { await this.subsDict[sync].cancel() };
    //   // this.subsDict = {};
    //   // let res = await this.http.get(this.config.logout).toPromise();
    //   let xhr = new XMLHttpRequest();
    // xhr.open('GET',this.config.logout,false);
    // xhr.withCredentials = true;
    // xhr.send(null);
    //   // this.log.log(`logout msg: ${res}`);
    //   this.authLoading$.next(false);
    //   this.goToOrigin();
    // } catch (error) {
    //   this.log.log(`LGT#1: ${JSON.stringify(error)}`);
    //   console.warn(error)
    //   return false;
    // }    
    // return true;
    //================================
    
    // this.authLoading$.next(true);
    // try {
    // for (let sync in this.subsDict) { await this.dbt.cancelSync2(this.subsDict[sync]); delete this.subsDict[sync]; };
    //   this.subsDict = {};
    //   await this.deleteTokens();
    //   // const resp1 = await this.http.delete(couchUrl, { withCredentials: true }).toPromise();
    //   localStorage.removeItem('login');
    //   // for (let dbIdx in this.otherDbs) {
    //   //   if (this.otherDbs[dbIdx]) {
    //   //     await this.otherDbs[dbIdx].close();
    //   //     // await this.otherDbs[dbIdx].destroy() 
    //   //     // indexedDB.deleteDatabase("_pouch_" + this.otherDbs[dbIdx].name);
    //   //   };
    //   // }; // delete restaurant dbs      
    //   this.otherDbs = [];

    //   // delete all rest dbs, the hard way (pouch db.destroy() seems not working)
    //   const restLogins: [] = (await this.dbt.getDocByIdPrefix('jwt:r', this.dbUserLocal)).rows.map(r => r.id.split(':')[2]);
    //   let dbDelCount = 0;
    //   restLogins.forEach(r => {
    //     let delPriv = indexedDB.deleteDatabase("_pouch_" + r + "-private");
    //     let delPub = indexedDB.deleteDatabase("_pouch_" + r + "-public");
    //     delPriv.onsuccess = () => {
    //       dbDelCount += 1;
    //       this.log.log(`${r}-private deleted`)
    //     };
    //     delPub.onsuccess = () => {
    //       dbDelCount += 1;
    //       this.log.log(`${r}-public deleted`)
    //     };
    //   });
    //   if (this.dbUserLocal) {
    //     let delUser = indexedDB.deleteDatabase("_pouch_" + this.dbUserLocal.name);
    //     delUser.onsuccess = () => {
    //       dbDelCount += 1;
    //       this.log.log(`${this.dbUserLocal.name} deleted`)
    //     };
    //     // await this.dbUserLocal.destroy(); 
    //   };
    //   let maxLogOutTime = 3000;
    //   while (dbDelCount < restLogins.length * 2 + 1 && maxLogOutTime > 0) {
    //     maxLogOutTime -= 100;
    //     await this.sleep(100);
    //   };
    //   this.dbUserLocal = null;
    //   this.dbUserRemote = null;
    //   this.loggedUser$.next(new User());
    //   this.authLoading$.next(false);
    //   return true;
    // } catch (error) {
    //   this.log.log(error);
    //   return false;
    // }
  }

  async deleteTokens() {
    if (this.dbUserLocal) { await this.dbt.deleteByIdDocSafe('jwt:user', this.dbUserLocal); };
    if (this.dbUserRemote) { await this.dbt.deleteByIdDocSafe('jwt:user', this.dbUserRemote); };
  }

  /**
   * Cancels all syncs to certain restaurant
   * 
   * @param restId id of restaurant
   */
  async cancelSyncsToRest(restId: string) {
    console.warn(restId);
    const subsToDelete = [`${restId}:changes:orderlist`, `${restId}:sync:dbsyncpriv`, `${restId}:sync:dbsyncpublic`];
    for (let subHand in subsToDelete) {
      if (subHand in this.subsDict) {
        await this.dbt.cancelSync2(subHand);
        delete this.subsDict[subHand];
      }
    }
  }

  // data-user-service-local-brezyl+test@gmail.com: Changes$1 {_events: {…}, _eventsCount: 3, _maxListeners: undefined, db: PouchDB, then: ƒ, …}
  // rest3:changes:menusync: Changes$1 {_events: {…}, _eventsCount: 4, _maxListeners: undefined, db: PouchDB, then: ƒ, …}
  // rest3:changes:orderlist: Changes$1 {_events: {…}, _eventsCount: 3, _maxListeners: undefined, db: PouchDB, then: ƒ, …}
  // rest3:sync:dbsyncpriv: Sync {canceled: false, push: Replication, pull: Replication, pushPaused: true, pullPaused: true, …}
  // rest3:sync:dbsyncpublic: Sync {canceled: false, push: Replication, pull: Replication, pushPaused: true, pullPaused: true, …}
  // sync-userdb-6272657a796c2b7465737440676d61696c2e636f6d: Sync {canceled: false, push: Replication, pull: Replication, pushPaused: true, pullPaused: true, …}




  /**
   * Check current user (logged or guest) using only LOCAL db.
   * If return User (guest or logged) it means, that this.dbUserLocal exists.
   * 
   * @returns false if dbUserLocal closed, undefined or null | new User (guest or logged) if dbUserLocal opened
   */
  async getCurrentUser(): Promise<false | User> {
    // indexedDB.databases() // not in every browser!
    try {
      // check if last login or guest
      let login = null;
      if (!this.dbUserLocal) {
        login = localStorage.getItem('login');
        if (login) {
          this.dbUserLocal = new PouchDB(this.getUserDatabaseName(login));
        } else {
          this.dbUserLocal = new PouchDB(this.config.guestDbName);
        };
      };

      // check if guest
      const guestData = await this.dbt.getDocById('guestdata', this.dbUserLocal);
      if (guestData !== 'not_found') { return new User({ guest: { login: guestData.login } }); };

      // check login
      // const token = await this.dbt.getDocById('jwt:user', this.dbUserLocal);
      const token = await this.getProperToken('jwt:user')
      // this.log.log(token);
      if (!token) {
        // await this.dbUserLocal.close();
        // await this.dbUserLocal.destroy();
        this.dbUserLocal = null;
        localStorage.removeItem('login');
        return false;
      }
      login = this.getUserNameFromToken(token.JWT);
      // this.log.log(login);
      const userDetails = await this.dbt.getDocById('userDetails', this.dbUserLocal);
      // this.log.log(userDetails);
      const name = userDetails === 'not_found' ? false : userDetails.fullName;
      return new User({ login, name });
    } catch (error) {
      this.log.log(`get current user error: ${JSON.stringify(error)}`, true);
      return false;
    }
  }

  /**
   * Check if used browser is proper for using app (indexedDB implemented).
   * 
   * @returns true if indexedDb successfully created and destroyed, else: false
   */
  async checkIfProperBrowser(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        const req = indexedDB.open('test' + Math.random())
        req.onerror = (e) => {
          // this.log.log(e);
          resolve(false);
        }
        req.onsuccess = async (e) => {
          const testDb: IDBDatabase = (e.target as any).result;
          testDb.close();
          indexedDB.deleteDatabase(testDb.name);
          resolve(true);
        }
      } catch (error) {
        // this.log.log(error);
        reject(error);
      }
    })

  }

  async checkIfDbExists(dbName): Promise<boolean> {
    return await this.dbt.checkIfDbExists(dbName);
  }

  /**
   * Opens or creates guest user database and saves it to this.dbUserLocal
   * returns 
   * 
   * @returns guest user object if guestDb created and opened, else false
   */
  async connectGuestDb(): Promise<boolean | User> {
    let guestdata;
    const currentUser = await this.getCurrentUser();
    if (currentUser && currentUser.login) {
      this.log.log('connect guest db executed while dbUserLocal existed');
      await this.dbUserLocal.close();
      await this.dbUserLocal.destroy();
      this.dbUserLocal = null;
    };
    try {
      this.dbUserLocal = new PouchDB(this.config.guestDbName);
      guestdata = await this.dbt.getDocById('guestdata', this.dbUserLocal);
      let token = await this.getProperToken('jwt:user');
      if (guestdata === 'not_found' || token === 'not_found' || token === false) {
        const JWT = (await this.http.post(this.config.getJWTForUser, { guest: true }).toPromise() as { token: string }).token;
        const login = this.getUserNameFromToken(JWT);
        guestdata = { login: login };
        const resp1 = await this.dbt.createOrUpdateDoc2({ doc: guestdata, db: this.dbUserLocal, id: 'guestdata' });
        const resp2 = await this.dbt.createOrUpdateDoc2({ doc: { JWT }, db: this.dbUserLocal, id: 'jwt:user' });
      }
      const resp = await this.dbt.getDocById('ckeys', this.dbUserLocal);
      if (resp === 'not_found') {
        const ckeys = await this.cryp.getKeyPairRSAOAEP();
        await this.dbt.createDoc(ckeys, this.dbUserLocal, 'ckeys');
      }
    } catch (error) {
      // this.log.log(error);
      return false;
    }
    return new User({ guest: guestdata });
  }


  /**
   * Opens or creates user local database.
   * 
   * @param login 
   * @param pass 
   * @returns true if dbUserLocal opened for proper user, else false
   */
  async connectUserDb({ login, pass = null, sync = false }): Promise<boolean> {
    // check if user local db is for proper user, if not delete the old db
    if (this.dbUserLocal && (this.dbUserLocal.name !== this.getUserDatabaseName(login))) {
      this.log.log('local user db for different user')
      await this.dbUserLocal.close();
      await this.dbUserLocal.destroy();
      this.dbUserLocal = null;
    };
    if (!this.dbUserLocal) {
      this.dbUserLocal = new PouchDB(this.getUserDatabaseName(login));
    };
    localStorage.setItem('login', login);
    // check if token exists in local db
    let token = await this.getProperToken('jwt:user');
    if (!token) {
      if (!pass) {
        this.log.log('no proper token in existing user db, password needed')
        return false;
      } else {
        const JWT = (await this.http.post(this.config.getJWTForUser, { login, pass }).toPromise() as { token: string }).token;
        const resp = await this.dbt.createOrUpdateDoc2({ doc: { JWT }, db: this.dbUserLocal, id: 'jwt:user' });
      }
    };

    if (sync) { await this.syncUserDb(); };
    return true;
  }

  /**
   * Basic connection of user dbs.
   * 
   * @param param0 {login,pass}
   * @returns 
   */
  async connectClient({ login = null, pass = null } = {}): Promise<boolean> {
    let user = null;
    if (login && pass) {
      await this.connectUserDb({ login, pass, sync: true });
      user = await this.getCurrentUser();
    } else {
      user = await this.getCurrentUser();
      // this.log.log(user)
      if (!user || !user.login) {
        user = await this.connectGuestDb();
      } else {
        if (user.login) {
          let connected = await this.connectUserDb({ login: user.login, sync: true });
          if (!connected) {
            // user (not guest!) jwt:user token expired or deleted/malformed
            this.loggedUser$.next(new User());
            this.router.navigateByUrl('/login');
            return false;
          };
        };
      };
    }

    // this.refreshLocalOrders(); not necessary because of syncUserDbs in connectUserDb
    if (!user) {
      this.loggedUser$.next(new User());
    } else {
      if (JSON.stringify(user) !== JSON.stringify(this.loggedUser$.value)) {
        this.loggedUser$.next(user);
      }
    }
    await this.refreshLocalOrders();
    this.userDbSynced$.next(true);
    this.authLoading$.next(false);
    this.log.log('connectClient finished')
    return true;
  }

  async syncUserDb(): Promise<boolean> {
    const token = await this.getProperToken('jwt:user');
    const login = this.getUserNameFromToken(token.JWT);
    const remoteDbName = `${this.config.couchRemoteURL}/${this.getUserDatabaseName(login)}`;
    // check if connected remote db has proper name
    if (this.dbUserRemote && (this.dbUserRemote.name !== remoteDbName)) {
      const oldDbName = this.dbUserRemote.name.split('/').pop();
      await this.dbt.cancelSync2(this.subsDict[`sync-${oldDbName}`]);
      delete this.subsDict[`sync-${oldDbName}`];
      await this.dbUserRemote.close();
      this.dbUserRemote = null;
    };
    if (!this.dbUserRemote) {
      this.dbUserRemote = new PouchDB(remoteDbName, {
        fetch: (url, opts) => {
          (opts as any).headers.set(`Authorization`, `Bearer ${token.JWT}`);
          opts.credentials = 'omit'; // !!!! IMPORTANT FOR JWT AUTH
          return PouchDB.fetch(url, opts);
        }
      });
    };
    if (await this.dbt.checkSync(`sync-${this.getUserDatabaseName(login)}`, this.subsDict)) {
      try {
        await PouchDB.replicate(this.dbUserRemote, this.dbUserLocal, { filter: 'user/basic' });
        await PouchDB.replicate(this.dbUserLocal, this.dbUserRemote);
      } catch (error) {
        this.log.log(`user db on-time replication failes: ${JSON.stringify(error)}`, true);
      }


      const options = {
        push: {
          live: true,
          retry: true,
          // since: 'now'
        },
        pull: {
          live: true,
          retry: true,
          // since: 'now',
          filter: 'user/basic'
        }
      };

      this.log.log('user db sync')
      this.subsDict[`sync-${this.getUserDatabaseName(login)}`] = PouchDB.sync(this.dbUserLocal, this.dbUserRemote, options)
        .on('change', (c) => this.log.log(`user db sync change: ${JSON.stringify(c)}`))
        .on('paused', (e) => this.log.log(`user db sync paused: ${JSON.stringify(e)}`))
        .on('active', () => this.log.log('user db sync active'))
        .on('denied', (c) => this.log.log(`user db sync denied: ${JSON.stringify(c)}`))
        .on('complete', (c) => this.log.log(`user db sync complete: ${JSON.stringify(c)}`))
        .on('error', async (e) => {
          this.log.log(`user db sync error: ${JSON.stringify(e)}`, true);
          await this.dbt.sleep(1000);
          await this.connectClient();
        })

    }
    return true;
  }

  async refreshLocalUserDb(): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      if (this.dbUserRemote) {
        await PouchDB.replicate(this.dbUserRemote, this.dbUserLocal, { filter: 'user/basic' })
          .on('complete', () => {
            this.log.log(`user db replicated`);
            resolve(true);
          })
          .on('error', (e) => { 
            // console.warn('RLUD#1');
            this.log.log(`RLUD#1: ${JSON.stringify(e)}`);
            reject(e); 
          })
      } else { resolve(true); };
    });
  }

  async refreshLocalOrders() {
    this.ordersInLocalUserDB$.next(await this.getAllOrdersFromLocalDB());
  }

  async getAllOrdersFromLocalDB(): Promise<Order[]> {
    let orders = []
    try {
      orders = (await this.dbt.getDocByIdPrefix('o:', this.dbUserLocal)).rows.map(r => r.doc) as Order[]
    } catch (error) {
      this.log.log('local orders not found')
    }
    return orders
  }

  /**
   * If return false for tokenId:'jwt:user', should logout!
   * 
   * @param tokenId 
   * @returns 
   */
  async getProperToken(tokenId): Promise<any> {
    if (!this.dbUserLocal) { this.log.log('no local user db'); return false; };
    const token = await this.dbt.getDocById(tokenId, this.dbUserLocal);
    if ((token as string) === 'not_found') { return false; };
    // if ((token as string) === 'indexed_db_went_bad') {
    //   // alert('Incompatible browser or history saving disabled.')
    //   return token;
    // };
    const content = JSON.parse(Buffer.from(token.JWT.split('.')[1].split('/').join('_').split('+').join('-'), 'base64').toString()) as { iat: number, exp: number, sub: string };
    const expireIn = content.exp * 1000;
    const expired = expireIn - (new Date()).getTime() <= 10 * 1000
    if (expired) { await this.dbt.deleteByIdDoc(tokenId, this.dbUserLocal); };
    const properToken = ('_rev' in token) ? { JWT: token.JWT, login: content.sub, _rev: token._rev } : { JWT: token.JWT, login: content.sub };
    return expired ? false : properToken;
  }



  getUserDatabaseName(login: string = this.loggedUser$.value.login): string {
    return 'userdb-' + login.split('')
      .map(c => c.charCodeAt(0).toString(16))
      .join('');
  }

  async getUserDetails(login: string = this.loggedUser$.value.login): Promise<any> {
    this.log.log(login)
    const token = await this.getProperToken('jwt:user');
    this.log.log(token)
    const headers = new HttpHeaders({ Authorization: `Bearer ${token.JWT}` });
    // const ans = await this.http.get(`${this.config.couchRemoteURL}/_session`, { headers }).toPromise();
    const ans = await this.http.get(`${this.config.couchRemoteURL}/_users/org.couchdb.user:${login}`, { headers }).toPromise();
    return ans;
    // this.log.log(ans)
  }

  getUserNameFromToken(token: string): string {
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString()).sub;
  }

  async checkIfUserExist(login: string): Promise<boolean> {
    try {
      const ans = await this.http.head(`${this.config.couchRemoteURL}/${this.getUserDatabaseName(login)}`).toPromise();
    } catch (error) {
      this.log.log('above XHR HEAD error is OK')
      if (error.status === 404) {
        return false
      }
      if (error.status === 401) {
        return true
      }
      this.log.log('user check suspicious')
    }
    return true
  }

  async checkIfRestIdExist(restId: string): Promise<boolean> {
    try {
      const ans = await this.http.head(`${this.config.couchRemoteURL}/${restId}-public`).toPromise();
    } catch (error) {
      this.log.log('above XHR HEAD error is OK');
      if (error.status === 404) {
        return false
      };
      if (error.status === 401) {
        return true
      };
      this.log.log('restId check suspicious')
    };
    return true
  };

  async sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // async login(login: string, pass: string): Promise<boolean> {
  //   let loginOk = false;
  //   try {
  //     if (!login || !pass || login.length < 3 || pass.length < 3) { throw new Error('no credentials'); }
  //     const couchUrl = `${this.config.couchRemoteURL}/_session`;
  //     const headers = new HttpHeaders({
  //       'Content-Type': 'application/x-www-form-urlencoded',
  //     });
  //     const data = `name=${login}&password=${pass}`;

  //     const userData = await this.http.post(couchUrl, data, { headers, withCredentials: true }).toPromise();
  //     loginOk = true;

  //     this.connectDBs(login);

  //     localStorage.setItem('login', login);
  //     this.loggedUser$.next({ login });
  //   } catch (error) {
  //     this.log.log(error);
  //   }
  //   return loginOk;
  // }

  // async getLongTermCookie(login: string, pass: string): Promise<boolean> {

  //   try {
  //     if (!login || !pass || login.length < 3 || pass.length < 3) { throw new Error('no credentials'); }
  //     await this.http.post(this.config.getLongTermCookieHost,
  //       { login, pass },
  //       { withCredentials: true }).toPromise();
  //     this.loggedUser$.next({ login });
  //     return true;
  //   } catch (error) {
  //     this.log.log(error);
  //     return false;
  //   }

  // }


}
